/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { Color } from '../models/Color';
import { ColorList } from 'src/app/common/fancy-firebase/lists/ColorList';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';

export class ColorsApi extends FancyActionableFirebase<Color, FancyAction, ColorList> {
	constructor(public data: ColorList) {
		super(data);
	}

	public addColor(color: string): void {
		const id = this.data.generateNewChildKey();
		this.addItemLegacy({ id, color }, id);
	}
}
